module.exports = __webpack_public_path__ + "assets/img/handy-bag.8400ef76.png";